import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders pre-sanitized HTML produced server-side from the repo's own content
 * files (see packages/server/src/lib/fileContent.js). Never pass user input.
 */
const HtmlContent = (props) => {
  if (!props.html) {
    return null;
  }

  return <div className={props.className} dangerouslySetInnerHTML={{ __html: props.html }} />;
};

HtmlContent.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
};

export default HtmlContent;
